/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limits_TitleInputs */

const en_svc_research_limits_title = /** @type {(inputs: Svc_Research_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What our research agents do not do.`)
};

const lv_svc_research_limits_title = /** @type {(inputs: Svc_Research_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko mūsu izpētes aģenti nedara.`)
};

/**
* | output |
* | --- |
* | "What our research agents do not do." |
*
* @param {Svc_Research_Limits_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limits_title = /** @type {((inputs?: Svc_Research_Limits_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limits_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limits_title(inputs)
	return en_svc_research_limits_title(inputs)
});